<template>
  <div class="att-panel">
    <div class="card-body p-0">
      <!-- Layer name and window controls -->
      <div class="att-header">
        <span class="att-title capitalize">{{ attributesName }}</span>

        <div class="att-header-actions">
          <template v-if="attributesName == 'errors'">
            <b-button
              class="att-nav-btn"
              size="sm"
              :disabled="disabledPrevious"
              @click="getNextError(false)"
            >
              Prev
            </b-button>
            <b-button
              class="att-nav-btn"
              size="sm"
              :disabled="disabledNext"
              @click="getNextError(true)"
            >
              Next
            </b-button>
          </template>
          <button
            id="minOrMaxAttributeElement"
            type="button"
            class="att-icon-btn"
            :title="attributesMinimized ? 'Maximize Attributes' : 'Minimize Attributes'"
            @click="$emit(attributesMinimized ? 'maximizeAttributes' : 'minimizeAttributes')"
          >
            <fa :icon="['fas', attributesMinimized ? 'window-maximize' : 'window-minimize']" />
          </button>
          <button
            type="button"
            class="att-icon-btn att-close"
            title="Close"
            aria-label="Close"
            @click="closeAttTable()"
          >
            <fa :icon="['fas', 'times']" />
          </button>
        </div>
      </div>

      <!-- All attributes and their values -->
      <div v-show="!attributesMinimized" class="att-body scroll-Container">
        <div
          v-for="(resp, index) in attribResponse"
          :key="index"
          class="att-row"
          v-if="resp.name != 'is_active'"
        >
          <div class="att-name">{{ resp.name }}</div>
          <div
            :id="'editor' + index"
            class="att-value"
            title="Copy value"
            @click="copyText(resp.value)"
          >
            <span class="att-value-text">
              {{ resp.name == 'created_at' || resp.name == 'created_date' || resp.name == 'updated_date' || resp.name == 'updated_on' ? resp.value ?
                resp.value.replace('Z', '') :
                resp.value : resp.value }}
            </span>
            <fa :icon="['fas', 'copy']" class="att-copy-icon" />
          </div>
        </div>

        <!-- Otonomo speed limit status -->
        <div
          class="att-otonomo"
          v-if="attributesName.toLowerCase().includes('otonomo') && globalIsUserAllowed('Otonomo_Status')"
        >
          <span class="att-otonomo-label">Speed limit status</span>
          <label class="att-radio">
            <input
              type="radio"
              name="typeFilter"
              :value="true"
              title="Active"
              v-model="status"
              @change="showBtn = true"
            />
            Active
          </label>
          <label class="att-radio">
            <input
              type="radio"
              name="typeFilter"
              :value="false"
              title="Inactive"
              v-model="status"
              @change="showBtn = true"
            />
            Inactive
          </label>
          <b-button
            v-if="showBtn"
            variant="primary"
            size="sm"
            class="att-update-btn"
            id="submitBtn"
            @click="updateOtonomo()"
          >
            Update
          </b-button>
        </div>
      </div>

      <!-- Pagination controls -->
      <div v-show="!attributesMinimized" class="att-footer">
        <div class="att-pager">
          <button
            type="button"
            class="att-pager-btn"
            :disabled="feature_index < 1"
            @click="getNextFeature(-1)"
          >
            <fa :icon="['fas', 'chevron-left']" />
          </button>
          <span class="att-pager-count">{{ feature_index + 1 }} of {{ features.length }}</span>
          <button
            type="button"
            class="att-pager-btn"
            :disabled="feature_index + 1 >= features.length"
            @click="getNextFeature(1)"
          >
            <fa :icon="['fas', 'chevron-right']" />
          </button>
        </div>
        <b-button class="close-btn" @click="closeAttTable()">Close</b-button>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* ── Panel shell ────────────────────────────────────────── */
.att-panel {
  background: #ffffff;
  color: #063c6d;
  border-radius: 14px;
  box-shadow: 0 12px 40px rgba(4, 30, 58, 0.28);
  overflow: hidden;
  font-family: 'Outfit', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

/* ── Header ──────────────────────────────────────────────── */
.att-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  background: linear-gradient(135deg, #0a5499, #063c6d);
  color: #fff;
}
.att-title {
  flex: 1 1 auto;
  min-width: 0;
  font-size: 1.2rem;
  font-weight: 600;
  letter-spacing: 0.2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.capitalize {
  text-transform: capitalize;
}
.att-header-actions {
  display: flex;
  align-items: center;
  gap: 6px;
}

/* Prev / Next */
.att-nav-btn {
  background: rgba(255, 255, 255, 0.14);
  border: 1px solid rgba(255, 255, 255, 0.25);
  color: #fff;
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.78rem;
  padding: 3px 10px;
  transition: background 0.15s ease, transform 0.12s ease;
}
.att-nav-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.26);
  transform: translateY(-1px);
}
.att-nav-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* Minimize / maximize / close */
.att-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.14);
  color: #fff;
  font-size: 0.8rem;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease, transform 0.15s ease;
}
.att-icon-btn:hover {
  background: rgba(255, 255, 255, 0.28);
  transform: scale(1.08);
}
.att-close:hover {
  background: #e5484d;
}

/* ── Attribute rows ──────────────────────────────────────── */
.att-body {
  max-height: 46vh;
  overflow-y: auto;
  overflow-x: hidden;
  /* padding: 4px 0; */
}
.att-body::-webkit-scrollbar {
  width: 8px;
}
.att-body::-webkit-scrollbar-thumb {
  background: rgba(6, 60, 109, 0.22);
  border-radius: 8px;
}
.att-body::-webkit-scrollbar-thumb:hover {
  background: rgba(6, 60, 109, 0.38);
}
.att-row {
  display: flex;
  align-items: stretch;
  padding: 7px 14px;
  border-bottom: 1px solid rgba(6, 60, 109, 0.06);
}
.att-row:nth-child(even) {
  background-color: rgba(6, 60, 109, 0.035);
}
.att-name {
  flex: 0 0 42%;
  padding-right: 10px;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: rgba(6, 60, 109, 0.6);
  word-break: break-word;
  align-self: center;
}
.att-value {
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  color: #063c6d;
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  padding: 3px 8px;
  border-radius: 6px;
  word-wrap: break-word;
  transition: background 0.12s ease;
}
.att-value-text {
  min-width: 0;
  word-break: break-word;
}
.att-copy-icon {
  flex: none;
  margin-left: auto;
  color: rgba(6, 60, 109, 0.35);
  font-size: 0.78rem;
  opacity: 0;
  transition: opacity 0.12s ease, color 0.12s ease;
}
.att-value:hover {
  background: rgba(10, 84, 153, 0.08);
}
.att-value:hover .att-copy-icon {
  opacity: 1;
  color: #0a5499;
}

/* ── Otonomo speed-limit status ──────────────────────────── */
.att-otonomo {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 14px;
  padding: 12px 14px;
  margin-top: 4px;
  background: rgba(6, 60, 109, 0.045);
  border-top: 1px solid rgba(6, 60, 109, 0.08);
}
.att-otonomo-label {
  flex: 0 0 42%;
  font-weight: 700;
  font-size: 0.85rem;
  color: #063c6d;
}
.att-radio {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  margin: 0;
  font-weight: 600;
  font-size: 0.85rem;
  color: #063c6d;
  cursor: pointer;
}
.att-update-btn {
  border-radius: 8px;
  font-weight: 600;
  margin-left: auto;
}

/* ── Footer / pagination ─────────────────────────────────── */
.att-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 10px 14px;
  background: rgba(6, 60, 109, 0.04);
  border-top: 1px solid rgba(6, 60, 109, 0.08);
}
.att-pager {
  display: flex;
  align-items: center;
  gap: 10px;
}
.att-pager-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  padding: 0;
  border: 1px solid rgba(6, 60, 109, 0.18);
  border-radius: 8px;
  background: #fff;
  color: #0a5499;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, transform 0.12s ease;
}
.att-pager-btn:hover:not(:disabled) {
  background: #eef4fb;
  border-color: #0a5499;
  transform: translateY(-1px);
}
.att-pager-btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}
.att-pager-count {
  font-size: 0.85rem;
  font-weight: 600;
  color: #063c6d;
  white-space: nowrap;
}
.close-btn {
  background: linear-gradient(135deg, #0a5499, #063c6d);
  border: none;
  color: #fff;
  border-radius: 8px;
  font-weight: 600;
  padding: 6px 22px;
  transition: filter 0.15s ease, transform 0.12s ease, box-shadow 0.15s ease;
}
.close-btn:hover {
  filter: brightness(1.08);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(6, 60, 109, 0.3);
}
</style>
<script>
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'MMP_Attributes',
  props: [
    'attributesName',
    'attributesMinimized',
    'attribResponse',
    'customerProjectId',
    'features',
    'feature_index',
    'map',
    'resetSequentialErrorButtons',
    'otonomoEditedSubcountry',
    'user'
  ],
  data() {
    return {
      currentErrorId: -1,
      disabledNext: false,
      disabledPrevious: false,
      errorFilters: '',
      index_item: null,
      names: null,
      showBtn: false
    }
  },
  methods: {
    closeAttTable() {
      this.$emit('closeAttTable')
    },
    getNextFeature(modifier) {
      this.index_item = this.feature_index + modifier
      this.$emit('showNextAttribute', this.index_item)
    },
    copyText(attributeValue) {
      /* Writes value to user's clipboard and shows
      a toast that displays the copied data */
      if (String(attributeValue).includes('Z')) {
        // substring is contained in the string
        attributeValue = String(attributeValue).replace('Z', '')
      }

      //Remove Z if exists from all the dates showing up in attribute panel.
      navigator.clipboard.writeText(attributeValue)
      this.$bvToast.toast(attributeValue, {
        autoHideDelay: 7000,
        title: 'Copied Value To Clipboard',
        toaster: 'b-toaster-top-right'
      })
    },
    getNextError(increment) {
      if (sessionStorage.token) {
        axios
          .get(process.env.API_LOCATION + '/api/error/sequentialFilteredError', {
            method: 'GET',
            headers: {
              'x-auth-token': sessionStorage.token
            },
            params: {
              currentId: this.currentErrorId,
              filter: this.errorFilters,
              increment: increment,
              projectId: this.customerProjectId
            }
          })
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log('sequentialFilteredError API Call Error: ' + content.errors)
              return
            }
            if ([0, 1].includes(content.length)) {
              /* If there is one or zero rows of data after
              this one, disable the appropriate button */
              this.disabledNext = increment
              this.disabledPrevious = !increment
            } else {
              /* If there are two or more rows of data after
              this one, enable both buttons */
              this.disabledNext = false
              this.disabledPrevious = false
            }
            if (content[0]) {
              content[0]['increment'] = increment
              content[0]['currentId'] = this.currentErrorId
              this.$emit('gotError', content[0])
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    updateErrorData() {
      this.map.getLayers().getArray().forEach(obj => {
        let properties = obj.getProperties()
        if (properties.name && (properties.name == 'errors')) {
          this.errorFilters = obj.getSource().getParams().CQL_FILTER
          this.currentErrorId = this.attribResponse[0].value
        }
      })
    },
    updateOtonomo() {
      if (sessionStorage.token) {
        axios
          .get(
            process.env.API_LOCATION +
            '/api/layer/updateOtonomoSign',
            {
              headers: {
                'x-auth-token': sessionStorage.token
              },
              params: {
                tableName: this.otonomoEditedSubcountry,
                status: this.status,
                id: this.attribResponse.filter(e => e.name == 'id')[0].value,
                username: this.user.name
              }
            }
          )
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log('Otonomo sign update Error: ' + content.errors)
            }
            else {
              this.showBtn = false
              this.$bvToast.toast('Status saved', {
                autoHideDelay: 5000,
                variant: 'success',
                solid: true,
                title: 'Data saved successfully.',
                toaster: 'b-toaster-top-center'
              })
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }

    }
  },
  updated() {
    this.updateErrorData()
  },
  mounted() {
    this.updateErrorData()
  },
  watch: {
    attribResponse: function (newValue, oldValue) {
      this.updateErrorData()
    },
    resetSequentialErrorButtons: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.disabledNext = false
          this.disabledPrevious = false
          this.$emit('errorButtonsReset')
        }
      },
      immediate: true
    }
  },
  computed: {
    ...mapGetters(['globalUserRole', 'globalAllowedUserModules', 'globalIsUserAllowed']),
    status: {
      get() {
        return this.attribResponse.find(e => e.name === 'is_active')?.value ?? false
      },
      set(val) {
        const item = this.attribResponse.find(e => e.name === 'is_active')
        if (item) item.value = val
      }
    }
  }
}
</script>
